import _implicitStylesheets from "./listingSummaryCard.css";
import _implicitScopedStylesheets from "./listingSummaryCard.scoped.css?scoped=true";
import _axImage from "ax/image";
import _adsStarRatings from "ads/starRatings";
import _aceButton from "ace/button";
import _axCard from "ax/card";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a class="title-link${0}" type-style="display-8"${"a0:href"}${2}>${"t1"}</a>`;
const $fragment2 = parseFragment`<p class="publisher${0}" type-style="body-3" util-style="ellipsis"${2}>${"t1"}</p>`;
const $fragment3 = parseFragment`<span class="detail-title${0}" type-style="body-3"${2}>${"t1"}</span>`;
const stc0 = {
  props: {
    "shadow": "elevation-2",
    "width": "100%"
  },
  key: 0
};
const stc1 = {
  classMap: {
    "content": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "header": true
  },
  key: 2
};
const stc3 = {
  "logo": true
};
const stc4 = {
  classMap: {
    "header-details": true
  },
  key: 4
};
const stc5 = {
  classMap: {
    "details": true
  },
  key: 10
};
const stc6 = {
  "decoration": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, ncls: api_normalize_class_name, k: api_key, i: api_iterator, f: api_flatten} = $api;
  return [$cmp.listing ? api_custom_element("ax-card", _axCard, stc0, [api_element("div", stc1, [api_element("div", stc2, [api_custom_element("ax-image", _axImage, {
    classMap: stc3,
    props: {
      "padding": "small",
      "height": "64px",
      "width": "64px",
      "imgSrc": $cmp.logo,
      "alt": $cmp.logoAlt
    },
    key: 3
  }), api_element("div", stc4, [api_static_fragment($fragment1, 6, [api_static_part(0, {
    attrs: {
      "href": $cmp.listingUrl
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.listingTitle))]), api_static_fragment($fragment2, 8, [api_static_part(1, null, api_dynamic_text($cmp.publisherName))]), api_custom_element("ads-star-ratings", _adsStarRatings, {
    props: {
      "size": "xsmall",
      "spaceBetween": "xsmall",
      "value": $cmp.averageRating,
      "reviewCount": $cmp.reviewCount,
      "readOnly": true,
      "labelPosition": "right",
      "ariaLabel": $cmp.screenReaderMessageForRating
    },
    key: 9
  })])]), $cmp.showDetails ? api_element("div", stc5, api_iterator($cmp.details, function (detail) {
    return detail ? api_element("div", {
      className: api_normalize_class_name(detail.id),
      key: api_key(11, detail.id)
    }, api_flatten([api_static_fragment($fragment3, 13, [api_static_part(1, null, api_dynamic_text(detail.title))]), api_iterator(detail.links, function (detailLink) {
      return detailLink ? api_custom_element("ace-button", _aceButton, {
        props: {
          "label": detailLink.text,
          "href": detailLink.href,
          "target": "_blank",
          "variant": "text",
          "size": "small"
        },
        key: api_key(14, detailLink.text)
      }) : null;
    })])) : null;
  })) : null]), api_custom_element("ax-image", _axImage, {
    classMap: stc6,
    props: {
      "imgSrc": $cmp.decorationImage
    },
    key: 15
  })]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5vi7c8sqd5j";
tmpl.legacyStylesheetToken = "undefined-_listingSummaryCard";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
